// Generated by ReScript, PLEASE EDIT WITH CARE

import * as AuthStore$PorterinFeature from "../domain/store/AuthStore.mjs";

var resend_sms_icon = {
  src: "/images/login/chat-outline.svg",
  width: 28.0,
  height: 28.0,
  alt: "sms icon"
};

var resend_sms_heading = AuthStore$PorterinFeature.ResendOtp.sms_heading;

var resend_sms_sub_heading = AuthStore$PorterinFeature.ResendOtp.sms_subheading;

var resend_sms = {
  icon: resend_sms_icon,
  heading: resend_sms_heading,
  sub_heading: resend_sms_sub_heading,
  option: /* SMS */1
};

var resend_whatsapp_icon = {
  src: "/images/login/whatsapp-outline.svg",
  width: 24.0,
  height: 24.0,
  alt: "whatsapp icon"
};

var resend_whatsapp_heading = AuthStore$PorterinFeature.ResendOtp.whatsapp_heading;

var resend_whatsapp_sub_heading = AuthStore$PorterinFeature.ResendOtp.whatsapp_subheading;

var resend_whatsapp = {
  icon: resend_whatsapp_icon,
  heading: resend_whatsapp_heading,
  sub_heading: resend_whatsapp_sub_heading,
  option: /* Whatsapp */0
};

var resend_otp_option = [
  resend_sms,
  resend_whatsapp
];

export {
  resend_sms ,
  resend_whatsapp ,
  resend_otp_option ,
}
/* No side effect */
